import type { PayloadAction } from '@reduxjs/toolkit'
import { createEntityAdapter, createSlice } from '@reduxjs/toolkit'

import type { Field } from '../../types'

export const fieldsAdapter = createEntityAdapter<Field>({
  selectId: field => field.id,
  sortComparer: (e1, e2) => e1.name.localeCompare(e2.name),
})

export const fieldsSlice = createSlice({
  name: 'fields',
  initialState: fieldsAdapter.getInitialState(),
  reducers: {
    addField(state, action: PayloadAction<Field>) {
      fieldsAdapter.upsertOne(state, action.payload)
    },
    addFields(state, action: PayloadAction<Field[]>) {
      fieldsAdapter.upsertMany(state, action.payload)
    },
  },
})

export default fieldsSlice.reducer
